import { configureStore } from "@reduxjs/toolkit";
import { useDispatch, useSelector, type TypedUseSelectorHook } from "react-redux";
import authReducer from "./authSlice";
import filesReducer from "./filesSlice";
import shareLinksReducer from "./shareLinksSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    files: filesReducer,
    shareLinks: shareLinksReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
